<template>
    <span>{{ value | currency('') }}</span>
</template>

<script>
export default {
    props: ['value'],
};
</script>



// WEBPACK FOOTER //
// Currency.vue?61448d0c